export function ChannelBadge({ channel, size = "sm" }) {
  const cfg = channel === "instagram"
    ? { label: "Instagram", cls: "text-[#E1306C] border-[#E1306C]/30 bg-[#E1306C]/10" }
    : { label: "WhatsApp", cls: "text-[#25D366] border-[#25D366]/30 bg-[#25D366]/10" };
  const padding = size === "xs" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs";
  return (
    <span
      data-testid={`channel-badge-${channel}`}
      className={`inline-flex items-center rounded-sm border font-mono uppercase tracking-wider ${padding} ${cfg.cls}`}
    >
      {cfg.label}
    </span>
  );
}
